import { useEffect } from 'react';

interface NioGlobal {
  initStarField?: () => void;
}

/**
 * The animated star-field runs once when the template bundle executes —
 * before SPA-navigated pages exist. Pages with a `.nk-star-field` (about,
 * home) call this to (re)initialize it for their own DOM once the Nio
 * bundle is available. initStarField is idempotent (guards already-seeded
 * containers via a data attribute).
 */
export function useBrightSaaSStarField() {
  useEffect(() => {
    const init = () => {
      const nio = (window as unknown as { Nio?: NioGlobal }).Nio;
      nio?.initStarField?.();
    };

    if ((window as unknown as { Nio?: NioGlobal }).Nio?.initStarField) {
      init();
    } else {
      window.addEventListener('brightsaas:loaded', init, { once: true });
    }

    return () => window.removeEventListener('brightsaas:loaded', init);
  }, []);
}
